import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCodesandbox = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.5 13.333V6.667a1.67 1.67 0 0 0-.833-1.442l-5.834-3.333a1.67 1.67 0 0 0-1.666 0L3.333 5.225A1.67 1.67 0 0 0 2.5 6.667v6.666a1.67 1.67 0 0 0 .833 1.442l5.834 3.333a1.67 1.67 0 0 0 1.666 0l5.834-3.333a1.67 1.67 0 0 0 .833-1.442"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.25 3.508 10 5.675l3.75-2.167M6.25 16.492v-4.325L2.5 10M17.5 10l-3.75 2.167v4.325M2.725 5.8 10 10.008 17.275 5.8M10 18.4V10"
      />
    </svg>
  );
};
export default SvgCodesandbox;
